module.exports = __webpack_public_path__ + "img/image.ccb223fd.svg";